import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../../../../components/Sidebar/Sidebar';
import UserProfileDropdown from '../../../../components/UserProfile/UserProfile';
import SeedsLogo from '../../../../assets/images/SeedsLogo.png';
import HomeSvg from '../../../../components/SVG/HomeSvg';
import { Row, Col, Container } from 'react-bootstrap';
import './Layout.css';

const Layout = () => {
    const navigate = useNavigate();

    return (
        <Container fluid className="user-management" style={{ padding: "0px" }}>
            <div className="applicationsDashboard">
                {/* LEFT SIDEBAR */}
                <Sidebar />

                <div className="dashboardMainContent">
                    {/* HEADER */}
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            <UserProfileDropdown />
                        </div>
                    </div>

                    <div className="userPageContent">
                        <div className="user-management-header d-flex justify-content-between align-items-center">
                            <div className="headerLeft d-flex align-items-center gap-2">
                                <div
                                    onClick={() => navigate('/user-management')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <HomeSvg fillColor={'#002355'} />
                                </div>
                                <h5 className="title mb-0">Seeds User Management</h5>
                            </div>
                        </div>

                        <div className="dashboard-content" style={{ flex: 1, padding: '24px' }}>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default Layout;